const COLUMN_TYPES = {
  mirror: 'mirror', //type inside a mirror columns setting_str->displayed_linked_columns[propertyPath]->["mirror"],
  email: 'email',
  formula: 'formula',
  board_relation: 'board_relation',
};

const formatColumnValue = (columnValue: any) => {
  let text = '';
  switch (columnValue.type) {
    case COLUMN_TYPES.mirror:
    case COLUMN_TYPES.board_relation:
      text = columnValue?.display_value || '';
      break;
    case COLUMN_TYPES.formula:
      break;
    default:
      text = columnValue?.text || '';
      break;
  }
  return {
    ...columnValue,
    title: columnValue?.column?.title,
    text,
  };
};

export const hydrateTextVal = (columnValues: any) => {
  // A utility function that hydrates text property path that had value previously before monday 2023-10 api release.
  const column_values = columnValues || [];
  for (const [index, column_value] of column_values.entries()) {
    column_values[index] = formatColumnValue(column_value);
  }
  return column_values;
};
